/**
 * 刷新app根节点页面
 */
define('util/client-refreshMain',['util/client-bridge'], function(clientBridge) {
    return function() {
        if (CLIENT_DATA.client === 'ssj') {
            clientBridge.call(clientBridge.uriSuishouji('requestUpdateWallet'));
        } else if (CLIENT_DATA.client === 'sgj') {
          clientBridge.call(clientBridge.callSuiguanjia('sgj://app/refreshAssetStatus'));
        } else if (CLIENT_DATA.client === 'kn') {
            clientBridge.call('cardniu://app/financeWalletEntranceUpdate?opt=1');
        }
    };
});

